































import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import UCSkeletonShimmer from '@shared/components/@atoms/UCSkeletonShimmer/UCSkeletonShimmer.vue';
import BaseHero from '@shared/components/@organisms/BaseHero/BaseHero.vue';
import BannerAspectRatio from '@shared/components/AspectRatio/BannerAspectRatio/BannerAspectRatio.vue';
import useBrandConfig from '@shared/composables/useBrandConfig';
import { IUCHeroGalleryItem } from './types';

export default defineComponent({
  name: 'UCHeroGallery',
  components: {
    BaseHero,
    UCSkeletonShimmer,
    BannerAspectRatio,
  },
  props: {
    slides: {
      type: Array as PropType<IUCHeroGalleryItem[]>,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    delay: {
      type: Number,
      default: undefined,
    },
    wrapAround: {
      type: Boolean,
      default: undefined,
    },
  },
  setup(props) {
    const { componentConfig } = useBrandConfig();
    const config = componentConfig.UCHeroGallery;

    const computedDelay = computed(() => props.delay ?? config.delay);
    const computedWrapAround = computed(() => props.wrapAround ?? config.wrapAround);

    return {
      computedDelay,
      computedWrapAround,
    };
  },
});
